export const environment = {
	intercomId: 'h52dueh6',
	env: process.env.REACT_APP_ENVIRONMENT || 'local',
	apiUrl: `${process.env.REACT_APP_BACKEND_URL}/api`,
	mixpanelToken: process.env.REACT_APP_MIXPANEL_TOKEN || '',
	sentryDsn: process.env.REACT_APP_SENTRY_DSN || '',
	releaseHash: process.env.REACT_APP_GIT_SHA || 'unknown',
	recaptchaKey: process.env.REACT_APP_RECAPTCHA_KEY || ''
};
